import React, { useContext } from "react";
import { HasPermissionFunction } from "./types";

export const PermissionsContext = React.createContext<HasPermissionFunction>(
  () => false
);
export const usePermissions = () =>
  useContext(PermissionsContext) as HasPermissionFunction;
